export const NEW_ACTIVE_USER = 'NEW_ACTIVE_USER';
export const NEW_USER_ACTIVITY = 'NEW_USER_ACTIVITY';
export const REMOVE_USER_ACTIVITY = 'REMOVE_USER_ACTIVITY';
export const USER_LEFT = 'USER_LEFT';
export const RESET_ACTIVE_USERS = 'RESET_ACTIVE_USERS';
//# sourceMappingURL=activeUsersActionTypes.js.map